import Header from "@components/layout/Header";
import RadiusContentWrapper from "@components/layout/RadiusContentWrapper";
import { colors } from "@styles/colors";
import { useNavigate } from "react-router-dom";
import { YStack, Text, ListItem, Button, XStack, View } from "tamagui";
import { RiArrowLeftSLine, RiFileTextLine, RiErrorWarningLine } from "react-icons/ri";
import TextCustom, { TextSize } from "@components/TextCoustom";

export const TransDetail = () => {
  const navigate = useNavigate();
  const prevPathname = "/account/wallet";
  const price = 1310;
  return (
    <YStack height="100dvh" width="100vw" background={colors.bg}>
      <Header>
        <XStack alignItems="center" onPress={() => navigate(prevPathname)}>
          <View mr="$2">
            <RiArrowLeftSLine size={20} color={colors.light} />
          </View>
          <TextCustom str="交易詳情" type={TextSize.SMALL} color={colors.light} bold={true} />
        </XStack>
        <YStack gap="$3" ai="center" jc="center" f={1}>
          <Text color={colors.primaryHover} fontSize={14}>
            消費支出
          </Text>
          <Text fontWeight="bold" color={colors.light} fontSize={30}>
            -NT$ {price.toLocaleString()}
          </Text>
          <Text color={colors.primaryHover} fontSize={14}>
            台中家 · 16kg × 2
          </Text>
        </YStack>
      </Header>
      <RadiusContentWrapper>
        <YStack ov="hidden" br="$4">
          <ListItem
            py="$4"
            background="#FFF"
            iconAfter={<Text fontWeight="bold">04/22 14:32</Text>}
            title="時間"
            borderBottomWidth={1}
            borderBottomColor="$gray3"
          />
          <ListItem
            py="$4"
            background="#FFF"
            iconAfter={<Text fontWeight="bold">#123</Text>}
            title="交易編號"
            borderBottomWidth={1}
            borderBottomColor="$gray3"
          />
          <ListItem
            py="$4"
            background="#FFF"
            iconAfter={<Text fontWeight="bold">台中家</Text>}
            title="帳戶"
            borderBottomWidth={1}
            borderBottomColor="$gray3"
          />
          <ListItem
            py="$4"
            background="#FFF"
            iconAfter={<Text fontWeight="bold">信用卡</Text>}
            title="付款方式"
            borderBottomWidth={1}
            borderBottomColor="$gray3"
          />
        </YStack>
        <XStack gap="$2">
          <Button
            fontWeight="bold"
            borderColor={colors.gray100}
            bg={"#FFF"}
            color={colors.primary}
            size={"$5"}
            flex={1}
            onPress={() => navigate(prevPathname)}>
            <RiFileTextLine color={colors.primary} />
            查看訂單
          </Button>
          <Button fontWeight="bold" borderColor={colors.gray100} bg={"#FFF"} color={colors.danger} size={"$5"} flex={1}>
            <RiErrorWarningLine color={colors.danger} />
            回報問題
          </Button>
        </XStack>
      </RadiusContentWrapper>
    </YStack>
  );
};

export default TransDetail;
